import AddIconGrey from '../../assets/icons/iconAddGrey.svg';
import PdfIcon from '../../assets/icons/pdfIcon.svg';
import './style.scss';
import {Link} from "react-router-dom";
import { buildProtectedImageUrl } from '../../utils/secureMedia';
import { formatDateInBogota } from '../../utils/dateTime';

function MeetingItem({ meeting, listState }) {
    function formatDate(meetingDate) {
        const formattedDate = formatDateInBogota(meetingDate, 'en-GB');
        return formattedDate ? formattedDate.replace(/\//g, '-') : '';
    }

    const normalizedListState = {
        ...listState,
        group: listState?.group,
        school: listState?.school,
        backTo: listState?.backTo
    };
    const signedAttendanceCount = Number(
        meeting?.signedAttendanceCount ?? meeting?.signed_attendance_count ?? 0
    );
    const hasSignedAttendance =
        meeting?.hasSignedAttendance === true ||
        meeting?.has_signed_attendance === true ||
        meeting?.hasSignedAttendance === 'true' ||
        meeting?.has_signed_attendance === 'true' ||
        signedAttendanceCount > 0;
    const programScope = String(
        meeting?.group?.school?.programScope ??
        meeting?.group?.school?.program_scope ??
        listState?.school?.programScope ??
        listState?.school?.program_scope ??
        listState?.group?.school?.programScope ??
        listState?.group?.school?.program_scope ??
        ''
    ).trim().toUpperCase();

    return (
        <div className='meeting-item'>
            <div className='content'>
                <p className='text'>{meeting?.type === 'MEETING' ? `Encuentro ${meeting.order}` : `Evento ${meeting.order}`}</p>

                {meeting?.meeting_date && (<div className='meeting-date'>
                        <p className='date'>Última Edición {formatDate(meeting.updated_at)}</p>
                    </div>
                )}
            </div>


            <div className='meeting-item__container'>
                <div className='images-container'>
                    {meeting?.meetingImages?.length > 0 ? (
                        <>
                            {meeting.meetingImages.map((m, i) => (
                                String(m?.type || '').toLowerCase() === 'pdf' ? (
                                    <img
                                        key={m?.id ?? i}
                                        className='photo1'
                                        src={PdfIcon}
                                        alt='PDF'
                                    />
                                ) : (
                                    <img
                                        key={m?.id ?? i}
                                        className='photo1'
                                        src={buildProtectedImageUrl(m?.id, !!m?.thumbnail)}
                                        alt='meeting preview'
                                        onError={(e) => {
                                            if (!m?.id) return;
                                            const fallbackUrl = buildProtectedImageUrl(m.id, false);
                                            if (e.currentTarget.src !== fallbackUrl) {
                                                e.currentTarget.src = fallbackUrl;
                                            }
                                        }}
                                    />
                                )
                            ))}
                        </>
                    ) : (
                        <>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                        </>
                    )}
                </div>
                {hasSignedAttendance && (
                    <Link
                        className='meeting-item__container__btn btn'
                        to={`/generar-listado-asistencia?evento_id=${meeting.id}`}
                        state={{
                            ...normalizedListState,
                            backTo: {
                                pathname: '/escuelas/grupo/lista_de_encuentros',
                                state: normalizedListState
                            }
                        }}>
                        <span className='btn__text'>Listado</span>
                        <span className='material-symbols-rounded btn__icon'>
                            print
                        </span>
                    </Link>
                )}
                {programScope === 'DIPLOM' && (
                    <Link
                        className='meeting-item__container__btn meeting-item__container__btn--satisfaction btn'
                        to={`/escuelas/grupo/lista_de_encuentros/satisfaccion?encuentro=${meeting.id}`}
                        state={{
                            backTo: {
                                pathname: '/escuelas/grupo/lista_de_encuentros',
                                state: normalizedListState
                            },
                            listState: normalizedListState
                        }}>
                        <span className='btn__text'>Satisfacción</span>
                        <span className='material-symbols-rounded btn__icon'>reviews</span>
                    </Link>
                )}
                <Link
                    className='meeting-item__container__btn meeting-item__container__btn--edit btn'
                    to={`/escuelas/grupo/lista_de_encuentros/encuentro?encuentro=${meeting.id}`}
                    state={{
                        ...normalizedListState,
                        backTo: {
                            pathname: '/escuelas/grupo/lista_de_encuentros',
                            state: normalizedListState
                        }
                    }}>
                    <span className='btn__text'>Editar </span>
                    <span className='material-symbols-rounded btn__icon'>
                              edit_square
                            </span>
                </Link>
            </div>
        </div>
    );
}

export default MeetingItem;
